import { AppDispatcher } from '@wsb/guac-widget-shared/lib/common/ols-core/shared-bundle';
import ProspectiveCustomerConstants from './ProspectiveCustomerConstants';
import * as APIUtils from './ProspectiveCustomerApi';
import ValidationsRegex from './ValidationsRegex';

const { dispatchServerAction } = AppDispatcher;

export function emailWasSent() {
  dispatchServerAction({
    type: ProspectiveCustomerConstants.EMAIL_SENT
  });
}

export function emailSentError() {
  dispatchServerAction({
    type: ProspectiveCustomerConstants.EMAIL_SENT_ERROR
  });
}

export function subscribeToOpenStore(email) {
  const { regex } = ValidationsRegex.email;

  dispatchServerAction({
    type: ProspectiveCustomerConstants.SET_EMAIL,
    data: email
  });

  if (!regex.test(email)) {
    dispatchServerAction({
      type: ProspectiveCustomerConstants.INVALID_EMAIL
    });

    return;
  }

  dispatchServerAction({
    type: ProspectiveCustomerConstants.SEND_EMAIL
  });

  APIUtils.subscribeToOpenStore(email)
    .then(function () {
      return emailWasSent();
    })
    .catch(function () {
      return emailSentError();
    });
}

export default {
  subscribeToOpenStore
};
